module.exports = __webpack_public_path__ + "static/media/in-house-team-freelancer-hero-image.55d87e88.webp";